module.exports = __webpack_public_path__ + "static/media/havecard-1.d1659c60.svg";